import React from 'react'
import { Modal, Box, Typography, Button, useMediaQuery } from '@mui/material'
import useInactivityPopup from '../../utils/hooks/useInactivityPopup' // Adjust the import path accordingly
import { theme } from '../theme'
import { addPrimaryCtaSx, addSecondaryFabSx } from '../common/addPrimaryCtaSx'
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 520,
  bgcolor: 'background.paper',
  border: '1px solid rgba(122, 129, 151, 0.14)',
  borderRadius: 6,
  boxShadow: '0 20px 48px rgba(20, 32, 60, 0.12)',
  display: 'flex',
  flexDirection: 'column',
}

interface InactivityPopupProps {
  disabled?: boolean
}

const InactivityPopup: React.FC<InactivityPopupProps> = ({ disabled = false }) => {
  const { open, handleStay, handleLeave } = useInactivityPopup(disabled)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Modal open={open} aria-labelledby="inactivity-popup-title" aria-describedby="inactivity-popup-description">
      <Box sx={{ ...style, p: isMobile ? 2.25 : 3.25, width: isMobile ? 'calc(100% - 24px)' : 520 }}>
        <Typography id="inactivity-popup-title" variant="h5" component="h2" sx={{ color: '#203864', fontWeight: 700 }}>
          Vous êtes toujours là ?
        </Typography>
        <Typography id="inactivity-popup-description" sx={{ mt: 1, color: '#6D7692', lineHeight: 1.5 }}>
          Votre session est inactive depuis un moment.
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            justifyContent: 'flex-end',
            width: '100%',
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            sx={{
              ...addSecondaryFabSx,
              minWidth: { xs: '100%', sm: 220 },
              width: { xs: '100%', sm: 220 },
              minHeight: 52,
              height: 52,
              whiteSpace: 'normal',
              lineHeight: 1.2,
              px: 2,
            }}
            onClick={handleLeave}
          >
            Revenir à la liste des animaux
          </Button>
          <Button
            variant="contained"
            sx={{
              ...addPrimaryCtaSx,
              minWidth: { xs: '100%', sm: 220 },
              width: { xs: '100%', sm: 220 },
              minHeight: 52,
              height: 52,
              whiteSpace: 'normal',
              lineHeight: 1.2,
              px: 2,
            }}
            onClick={handleStay}
          >
            Rester sur la page
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default InactivityPopup
